import axios from 'axios';
import { clearAuthAndRedirect } from '@/entities/Auth';
import { LocalStorageService } from '@/shared/services/localStorage.service';

export const $api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:3001',
  headers: {
    Accept: 'application/json',
  },
  withCredentials: true,
});

$api.interceptors.request.use(
  (config) => {
    const accessToken = LocalStorageService.getAccessTokenFromAnyStorage();
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

$api.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Редирект при 401 (Unauthorized), или 403 (Forbidden) если error.message === "Forbidden"
    if (
      error.response?.status === 401 ||
      (error.response?.status === 403 && error.message === 'Forbidden')
    ) {
      clearAuthAndRedirect('/login');
    }
    return Promise.reject(error);
  },
);
